// fetchAddOnListEpic.ts
import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { FETCH_ADD_ON_LIST_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveAddOnList } from 'Actions';

const fetchAddOnListEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_ADD_ON_LIST_REQUEST),
    debounceTime(500),
    switchMap((action) =>
      from(
        service.post(
          `${import.meta.env.VITE_API_DOMAIN}/api/add_ons/list?page=all`,
          action.options
        )
      ).pipe(
        map((response) => receiveAddOnList(response.data.addOns)),
        catchError((error) => {
          console.error('fetchAddOnListEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default fetchAddOnListEpic;
